import React from "react";
import { useTranslation } from "react-i18next";

const About = (props) => {
  const { t } = useTranslation("clientSite");
  return (
    <div className="aboutCard">
      <div className="sectionIntro sectionIntro--left">
        <span className="sectionIntro__eyebrow">{t("header.nav.about")}</span>
        <h2 className="sectionIntro__title">{props.site.aboutUsPageTitle}</h2>
        <p className="sectionIntro__text">{props.site.aboutUsDescription}</p>
      </div>
    </div>
  );
};

export default About;
